exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1C-4H{margin-top:5px}._2KPcF{width:20px;margin-right:5px}._1eD9-,._2KPcF{padding-bottom:2px;margin-left:2px}._1eD9-{width:18px}", ""]);

// exports
exports.locals = {
	"root": "_1C-4H",
	"instaIcon": "_2KPcF",
	"fbIcon": "_1eD9-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/SocialLinks/SocialLinks.css
// module id = 2765
// module chunks = 32 36